import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";

export default {
  namespaced: true,
  state: {
    bannerOffers: [],
    whatmakeUsDiff: {},
  },
  getters: {},
  mutations: {
    updateBannerOffer(state, payload) {
      state.bannerOffers = payload;
    },
    updateWhatMakesUsDiff(state, payload) {
      state.whatmakeUsDiff = payload;
    },
  },
  actions: {
    bannerOfferApi({ commit, state }, payload = "Banner") {
      ApiCalls.BANNER_OFFERS_API({
        headers: Headers(),
        payload: payload,
      })
        .then(function (response) {
          if (response?.data?.length > 0) {
            commit("updateBannerOffer", response.data);
          }
        })
        .catch(function (error) {
          commit("updateBannerOffer", {});
        });
    },
    whatMakesUsDiffApi({ commit, state }, payload = "WhatMakesUsDiff") {
      ApiCalls.BANNER_OFFERS_API({
        headers: Headers(),
        payload: payload,
      })
        .then(function (response) {
          if (response?.data?.length > 0) {
            commit("updateWhatMakesUsDiff", response.data[0]);
          }
        })
        .catch(function (error) {
          commit("updateWhatMakesUsDiff", {});
        });
    },
  },
};
